
import DriverTripPayment from "./DriverTripPayment/DriverTripPayment"
import DriverSalary from "./DriverSalary/DriverSalary"
import DriverAdvancePay from "./DriverAdvancePay/DriverAdvancePay"
import { Route } from "react-router-dom/cjs/react-router-dom.min"


export const branchApiNm = {
  
  getJobOrderAllDetail: "/branch/getJobOrderAllDetail"
}
export const extraPageName = {
  DriverTripPayment: "ค่าเที่ยว พนักงานขับรถ",
  DriverSalary: "เงินเดือนพนักงานขับรถ",
  DriverAdvancePay: "เงินเบิกล่วงหน้า",}
export const extraPageMenu = [
  { page: "DriverTripPayment", num: "8.1", menuName: extraPageName.DriverTripPayment, prNum: 8, permission: "EXE;FIN"},
  { page: "DriverAdvancePay", num: "8.2", menuName: extraPageName.DriverAdvancePay, prNum: 8},
  { page: "DriverSalary", num: "8.3", menuName: extraPageName.DriverSalary, prNum: 8, permission: "EXE;FIN"},
  ]

export const extraRoute = (path)=> [
  <Route key={"DriverTripPayment"} path={`${path}/DriverTripPayment`} ><DriverTripPayment /> </Route>,
  <Route key={"DriverAdvancePay"} path={`${path}/DriverAdvancePay`} ><DriverAdvancePay /> </Route>,
  <Route key={"DriverSalary"} path={`${path}/DriverSalary`} ><DriverSalary /> </Route>,
  
]

export const extraMainRoute = (path)=> []
